
export const LOCATION_RADIUS_KM_MIN = 1;
export const LOCATION_RADIUS_KM_MAX = 500;
export const LOCATION_RADIUS_KM_STEP = 1;
